<template>
  <!-- Modal Overlay -->
  <div v-if="showModal" class="modal-overlay" @click.self="closeModal">
    <div class="modal-content">
      <!-- <span class="back-button" @click="goBack">&#8592;</span> -->
      <span class="close-button" @click="closeModal">&times;</span>

      <h2>輸入卡號</h2>

      <div class="card-image">
        <!-- aabb -->
        <img v-if="selectedOfferCard" :src="getOfferCardImageURL(selectedOfferCard)" @error="onImageError" />
        <img  v-else  src="@/assets/Newidols.ru-Shop-Credit-card.256.png" alt="Credit Card" />

      </div>

      <h3 v-if="selectedOfferCard">{{ selectedOfferCard.bank + ' | ' + selectedOfferCard.name }}</h3>
      <div v-else style="height:24px;"></div>
      <!-- <h3 v-else style="margin-bottom:16px;">信用卡號</h3> -->

      <!-- Card Number Groups -->
      <div class="card-num-groups">
        <input
    type="tel"
    inputmode="numeric"
    pattern="[0-9]*"
    v-model="cardNumberGroup1"
    maxlength="4"
    placeholder="XXXX"
          class="card-input"
          ref="cardInput1"
          @input="handleInput('cardNumberGroup1', 'cardInput2')"
          @keypress="onlyNumber"
          @keydown="handleBackspace('cardNumberGroup1', null, $event)"
        />
        <input
    type="tel"
    inputmode="numeric"
    pattern="[0-9]*"
    v-model="cardNumberGroup2"
    maxlength="4"
    placeholder="XXXX"
          class="card-input"
          ref="cardInput2"
          @input="handleInput('cardNumberGroup2', 'cardInput3')"
          @keypress="onlyNumber"
          @keydown="handleBackspace('cardNumberGroup2', 'cardInput1', $event)"
        />
        <input
    type="tel"
    inputmode="numeric"
    pattern="[0-9]*"
    v-model="cardNumberGroup3"
    maxlength="4"
    placeholder="XXXX"
          class="card-input"
          ref="cardInput3"
          @input="handleInput('cardNumberGroup3', 'cardInput4')"
          @keypress="onlyNumber"
          @keydown="handleBackspace('cardNumberGroup3', 'cardInput2', $event)"
        />
        <input
    type="tel"
    inputmode="numeric"
    pattern="[0-9]*"
    v-model="cardNumberGroup4"
    maxlength="4"
    placeholder="XXXX"
          class="card-input"
          ref="cardInput4"
          @input="handleInput('cardNumberGroup4', 'expireDate')"
          @keypress="onlyNumber"
          @keydown="handleBackspace('cardNumberGroup4', 'cardInput3', $event)"
        />
      </div>

      <!-- Expire Date -->
      <div class="card-num-groups expire-date">
        <label>到期日</label>
        <input
          ref="expireDate"
    type="tel"
    inputmode="numeric"
    pattern="[0-9]*"
    v-model="expireDate"
    maxlength="4"
    placeholder="MMYY"
    class="card-input"
          @input="handleInput('expireDate', 'applyButton')"
          @keypress="onlyNumber"
          @keydown="handleBackspace('expireDate', 'cardNumberGroup4', $event)"
        />
      </div>

      <button class="apply-button" @click="useDiscount" ref="applyButton">
        使用優惠折抵
      </button>
    </div>
  </div>
</template>

<script>
import { getFullImageURL, onImageError } from '@/util/util';
import { nextTick } from 'vue';

export default {
  data() {
    return {
      showModal: true,
      // Separate each group of 4 digits
      cardNumberGroup1: '',
      cardNumberGroup2: '',
      cardNumberGroup3: '',
      cardNumberGroup4: '',
      expireDate: '',
    };
  },
  props: {
    selectedOfferCard: {
      type: Object,
      required: true,
    },
  },
  methods: {
    onImageError,
    getFullImageURL,
    closeModal() {
      // this.showModal = false;
      this.$emit('go-back-to-select-card');
    },
    goBack() {
      this.showModal = false;
      this.$emit('go-back-to-select-card');
    },
    useDiscount() {
      const cardNumber =
        this.cardNumberGroup1 +
        this.cardNumberGroup2 +
        this.cardNumberGroup3 +
        this.cardNumberGroup4;

      // Basic validation checks
      if (cardNumber.length !== 16 || isNaN(cardNumber)) {
        alert('請輸入有效的16位數信用卡號');
        return;
      }
      if (this.expireDate.length < 4 || isNaN(this.expireDate)) {
        alert('請輸入有效的到期日 (MMYY)');
        return;
      }

      console.log('CardNumber Entry: ', cardNumber, this.expireDate);

      // Emit the data to the parent
      this.$emit('updateState', { key: 'cardNumber', value: cardNumber });
      this.$emit('updateState', { key: 'expireDate', value: this.expireDate });


      this.$emit('card-number-entered');
    },
    getOfferCardImageURL(offercard) {
      return getFullImageURL(offercard.card_image);
    },

    // Auto-focus next input when the current one is filled
    handleInput(currentGroup, nextRef) {
      const currentValue = this[currentGroup];
      if (currentValue.length === 4) {
        nextTick(() => {
          if (nextRef === 'applyButton') {
            this.$refs.applyButton.focus();
          } else {
            this.$refs[nextRef].focus();
          }
        });
      }
    },

    // If user presses backspace and the input is empty, focus previous
    handleBackspace(currentGroup, prevRef, event) {
      const currentValue = this[currentGroup];
      if (event.key === 'Backspace' && currentValue.length === 0 && prevRef) {
        this.$refs[prevRef].focus();
      }
    },

    // Restrict input to numbers only
    onlyNumber(event) {
      const char = String.fromCharCode(event.which);
      if (!/[0-9]/.test(char)) {
        event.preventDefault();
      }
    },
  },
  mounted() {
    // Auto-focus the first input on mount
    this.$nextTick(() => {
      this.$refs.cardInput1.focus();
    });
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  background-color: white;
  border-radius: 10px;
  margin-top: 20vh;
  width: 640px;
  height:680px;
  padding: 24px 30px;
  position: relative;
  text-align: center;

  display: flex;
  flex-direction: column;
  align-items: center;

  box-sizing: border-box;
}

h2 {
  font-size: 24px;
  line-height: 33.6px;
  color: var(--green03);
  margin-top: 0px;
  margin-bottom: 68px;
}

.back-button,
.close-button {
  position: absolute;
  font-size: 24px;
  cursor: pointer;
  color: black;
}

.back-button {
  top: 10px;
  left: 10px;
}

.close-button {
  top: 10px;
  right: 10px;
}

.card-image {
  width: 240px;
  height: 150px;
  border-radius: 12px;

  margin: 0;
}

.card-image img {
  width: 100%;
  height: 100%;
  border-radius: 12px;
  object-fit: cover;
}

h3 {
  font-size: 20px;
  line-height: 30px;
  color: var(--gray15);
  margin-top: 24px;
  margin-bottom: 32px;
}

/* Card number inputs */
.card-num-groups {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 5px;
  margin-bottom: 20px;
}

.card-input {
  width: 140px;
  height: 64px;
  font-size: 24px;
  font-weight: 700;
  text-align: center;
  border: 1px solid var(--gray06);
  border-radius: 8px;
  box-sizing: border-box;
}

/* Expire date styling */
.expire-date {
  display: flex;
  flex-direction: column;
}

.expire-date label {
  font-size: 20px;
  font-weight: 700;
  line-height: 24px;
  text-align: center;
  color: var(--gray15);
  margin-bottom: 8px;
  display: block;
}

/* Submit button */
.apply-button {
  /* min-height: 48px; */
  padding: 16px 32px;
  border-radius: 99px;
  background-color: var(--green03);
  color: white;
  border: none;
  margin-top: 16px;
  margin-bottom: 32px;
  font-size: 18px;
  font-weight: 700;
  line-height: 26.1px;
  text-align: center;
  box-sizing: border-box;

  
}

.apply-button:hover {
  background-color: var(--green02);
}

/* Responsive Styles */
@media (max-width: 560px) {
  .modal-content {
    margin-top: 15vh;
    width: 343px;
    height: 480px;
  }

  h2 {
    font-size: 20px;
    line-height: 30px;
    margin-top: -7px;
    margin-bottom: 40px;
  }

  h3 {
    font-size: 16px;
    line-height: 24px;
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .card-image {
    width: 160px;
    height: 100px;
    border-radius: 8px;
    margin-top:0px;
  }

  .card-num-groups input {
    width: 72px;
    height: 42px;
    font-size: 14px;
  }

  .expire-date label {
    font-size: 16px;
    line-height: 21.56px;
  }

  .apply-button {
    padding: 10px 20px;
    margin-top: 0px;
    font-size: 14px;
    line-height: 21.56px;
  }
}
</style>
